module.exports = __webpack_public_path__ + "img/atmo-aqs.d2da6428.png";